// @flow strict
import React from 'react';
import moment from 'moment';
import { Link } from 'gatsby';
import type { Edges } from '../../types';
import styles from './Feed.module.scss';

type Props = {
  edges: Edges,
};

const Feed = ({ edges }: Props) => {
  return (
    <div className={styles['feed']}>
      {edges.map(edge => {
        const slug = edge.node.fields.slug.split('/posts')[1];
        return (
            <div className={styles['feed__item']} key={edge.node.fields.slug}>
              <div className={styles['feed__item__img-wrapper']}>
                <Link to={`/blog${slug}`}>
                <img
                    src={edge.node.frontmatter.socialImage}
                    alt={edge.node.frontmatter.socialImage}
                />
                </Link>
              </div>
              <div className={styles['feed__item-meta']}>
                <time
                    className={styles['feed__item-meta-time']}
                    dateTime={moment(edge.node.frontmatter.date).format(
                        'MMM DD'
                    )}
                >
                  {moment(edge.node.frontmatter.date).format('MMM DD')}
                </time>
                <span className={styles['feed__item-meta-divider']} />
                <span className={styles['feed__item-meta-category']}>
              <Link
                  to={`/blog${edge.node.fields.categorySlug}`}
                  className={styles['feed__item-meta-category-link']}
              >
                #{edge.node.frontmatter.category}
              </Link>
            </span>
              </div>
              <h2 className={styles['feed__item-title']}>
                <Link
                    className={styles['feed__item-title-link']}
                    to={`/blog${slug}`}
                >
                  {edge.node.frontmatter.title}
                </Link>
              </h2>
            </div>
        )
      })}
    </div>
  );
};

export default Feed;
